export default "__VITE_ASSET__c6f661d0__"